import { useDroppable } from '@dnd-kit/core';
import { useAppSelector } from 'app/hooks';
import { LevelType } from 'data/types';
import LevelPickerLevel from './level-picker-level';

type LevelPickerProps = Readonly<{
  currentSectionId?: string;
  onLevelClick?: (level: LevelType) => void;
}>;

export default function LevelPicker({
  currentSectionId,
  onLevelClick
}: LevelPickerProps) {
  const { structure } = useAppSelector((state) => state.structure);
  const { setNodeRef } = useDroppable({
    id: 'level-list',
    disabled: false
  });

  return (
    <div
      id='level-picker'
      ref={setNodeRef}
      className='absolute left-2 top-2 z-20 flex flex-col gap-1 rounded-lg bg-white p-2 shadow-md'
    >
      {structure.toReversed().map((level) => (
        <LevelPickerLevel
          key={level.uniqueId}
          level={level}
          index={structure.findIndex((l) => l.uniqueId === level.uniqueId)}
          currentSectionId={currentSectionId}
          onLevelClick={onLevelClick}
        />
      ))}
    </div>
  );
}
